import React from 'react';
import Draggable from 'react-draggable';
import { Resizable } from 're-resizable';
import ClearIcon from '@material-ui/icons/Clear';
import { TextField, Typography, MenuItem } from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(() => ({
  clearContainer: {
    position: 'absolute',
    right: '15px',
    top: '15px',
    zIndex: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    cursor: 'pointer'
  },
  stepOrderContainer: {
    position: 'absolute',
    left: '5px',
    top: '5px',
    zIndex: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    height: '30px',
    width: '30px'

  },
  resizableContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }

}));

export const SignatureElement = ({ x, y, step, dropZoneRef, updateStepsProps, stepOrder, numberOfPages }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleChange = (event, step) => {
    updateStepsProps({ step, data: { eventType: 'onChangeEmail', data: { email: event.target.value } } });
  };

  const handleValidate = (event, step) => {
    updateStepsProps({ step, data: { eventType: 'onValidateEmail', data: { email: event.target.value } } });
  };
  const handlePageChange = (event, step) => {
    updateStepsProps({ step, data: { eventType: 'onPageChange', data: { pageNumber: event.target.value } } });
  };

  return (
    <Draggable
      scale={1}
      bounds='parent'
      handle='.custom-drag-handle'
      disabled={step.step.type === 'qrSignStep'}
      position={{ x: x, y: y }}

      onStop={(event, data) => {
        updateStepsProps({ step,
          data: {
            event,
            data,
            dropZoneRef,
            eventType: 'onDrag'
          } });
      }}
    >
      <div
        style={{
          cursor: step.step.type === 'qrSignStep' ? 'not-allowed' : 'all-scroll',
          width: step.size.width,
          height: step.size.height,
          position: 'absolute'
        }}
      >
        { step.step.type !== 'qrSignStep' && <div
          className={classes.clearContainer}
          onClick={() => updateStepsProps({ step, data: { eventType: 'onDelete' } })}>
          <ClearIcon
            color='black' />
        </div>}
        { step.step.type !== 'qrSignStep' && <div
          className={classes.stepOrderContainer}
          onClick={() => updateStepsProps({ step, data: { eventType: 'onDelete' } })}>
          <Typography>{stepOrder}</Typography>
        </div>}
        <div className={classes.resizableContainer}>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Resizable
              enable={step.step.type === 'qrSignStep'
                ? { top: false, right: false, bottom: false, left: false, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false }
                : { top: true, right: true, bottom: true, left: true, topRight: false, bottomRight: true, bottomLeft: false, topLeft: false }}
              id={step.signaturePositionId}
              style={{
                border: 'solid 2px #019591',
                background: step.positioned ? 'rgba(191, 235, 237, 0.5)' : 'rgba(235, 104, 14, 0.8)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '105%',
                width: '105%'

              }}
              defaultSize={{
                width: '100px',
                height: '100px'
              }}
              size={{
                width: step.size.width,
                height: step.size.height

              }}
              onResizeStop={(e, direction, ref, d) => {
                updateStepsProps({ step,
                  data: {
                    event: e,
                    direction,
                    ref,
                    d,
                    eventType: 'onResize'
                  } });
              }}
            >
              <div
                style={{
                  width: '95%',
                  height: '95%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                className='custom-drag-handle'
              >
                <Typography style={{ color: 'black', marginBottom: '10px', overflow: 'auto' }} >{t(`customFlow:steps:${step.step.type}`)}</Typography>
                { step.step.type !== 'qrSignStep' && <ArrowRightIcon
                  style={{
                    position: 'absolute',
                    right: '-12px',
                    bottom: '-12px',
                    transform: 'rotate(45deg)'
                  }}
                  fontSize='large' />}
              </div>
            </Resizable>
          </div>
          { step.signaturePositionId !== 'qrDefault' && !step.step.automatic &&
          <div style={{
            marginTop: '15px',
            minWidth: 'max-content'
          }}>
            <TextField
              onChange={(e) => handleChange(e, step)}
              onBlur={(e) => handleValidate(e, step)}
              value={step.step.email || ''}
              id='input-step-email'
              label='Email'
              variant='filled' />
          </div>}
          {step.signaturePositionId !== 'qrDefault' && numberOfPages.length > 1 &&
          <div
            style={{
              marginTop: '15px',
              minWidth: '206px'
            }}
          >
            <TextField
              style={{
                width: '100%'
              }}
              select
              label={t('customFlow:selectPage')}
              onChange={(e) => handlePageChange(e, step)}
              value={step.pageNumber}
              id='input-step-page'
              variant='filled'
            >
              {numberOfPages.map((number) => (
                <MenuItem key={number} value={number}>
                  {`${t('customFlow:page')}` + number}
                </MenuItem>
              ))}
            </TextField>
          </div>}
        </div>
      </div>
    </Draggable>

  );
};

export default SignatureElement
;
